import EvalUserManagement from './src/main';

/* istanbul ignore next */
EvalUserManagement.install = function(Vue) {
  Vue.component(EvalUserManagement.name, EvalUserManagement);
};

export default EvalUserManagement;
